import { createModelSegment } from 'client/data/luckdragon/segment';
import { withMetrics } from 'client/data/api/api-metrics';
import { EdmundsAPI } from 'client/data/api/api-client';

export function buildPressReleasesPath() {
  return 'pressReleases';
}

const PAGE_SIZE = 69;
const MAX_TOTAL_PAGES = 20;

export const PressModel = createModelSegment('press', [
  {
    path: 'pressReleases',
    resolve(match, context) {
      const api = withMetrics(EdmundsAPI, context);

      return api.fetchJson(`/seo/v1/sitemap/?category=press/&pagenum=1&pagesize=${PAGE_SIZE}`).then(response => {
        if (!response || !response.results) {
          return [];
        }

        const { results, totalPages = 1 } = response;

        if (!Number.isInteger(totalPages) || totalPages < 1) {
          return results;
        }

        const safeTotalPages = Math.min(totalPages, MAX_TOTAL_PAGES);

        if (safeTotalPages <= 1) {
          return results;
        }

        const remainingPageFetches = [];
        for (let pagenum = 2; pagenum <= safeTotalPages; pagenum += 1) {
          remainingPageFetches.push(
            api
              .fetchJson(`/seo/v1/sitemap/?category=press/&pagenum=${pagenum}&pagesize=${PAGE_SIZE}`)
              .then(pageResponse => (pageResponse && pageResponse.results ? pageResponse.results : []))
          );
        }

        return Promise.all(remainingPageFetches).then(remainingResults =>
          remainingResults.reduce((acc, pageResults) => acc.concat(pageResults), results)
        );
      });
    },
  },
]);
